import * as Yup from 'yup';

export const stepOneSchema = Yup.object({
  //   project: Yup.string().required('Project is required'),
  course_available_id: Yup.string().required('Course is required'),
  title: Yup.string().required('Title is required'),
  courseType: Yup.string().required('Course type is required'),
  ageFrom: Yup.number().required(),
  ageTo: Yup.number().required(),
  // duration: Yup.string().required('Duration is required'),
  // lessons: Yup.string().required('Lessons are required'),
  language: Yup.array().of(Yup.number()).required('Language required'),
  certificate: Yup.string().required('Certificate is required'),
  // testimonialVideoLink: Yup.string().required('Testimonial Video is required'),
  // brochureUrl: Yup.array().of(Yup.string()).min(1, 'Brochure is required'),
  // courseBannerUrl: Yup.array().of(Yup.string()).min(1, 'Course Banner is required'),
});

export const stepTwoSchema = Yup.object({
  description: Yup.string().required('Description is required'),
  highlights: Yup.array().of(Yup.string().required('Required')).min(1),
  reasons: Yup.array().of(Yup.string().required('Required')).min(1),
  focusArea: Yup.string().required('Focus area required'),
  minSessionPerWeek: Yup.string().required('Required'),
});
